import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import {
  FiArrowRight,
  FiBookOpen,
  FiCheck,
  FiChevronRight,
  FiExternalLink,
  FiFileText,
  FiMail,
  FiMapPin,
  FiPhone,
  FiPlay,
} from "react-icons/fi";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
} from "react-icons/fa";

import schoolLogo from "../../image/logo/Logo.png";
import heroImage from "./Banner Image.webp";
import growthImage from "./growth-reference.png";
import careImage from "./interaction-with-teacher-banner.png";
import academicsImage from "../../image/photo-gallery/Home Page Gallery 4.webp";
import parentImage from "../../image/parents/d.png";
import studentStoryImage from "../../image/photo-gallery/Home page gallery 1.webp";
import campusVideo from "../../video/Visit.mp4";
import trustIconSheet from "./Icon set 1..bottom banner.png";
import whyIconSheet from "./Icon set 2- Why HGS Bhimtal.png";
import growthIconSheet from "./Icon set 3 Holistic growth beyond books.png";
import careAcademicIconSheet from "./Icon set 4- academic excellence & Highest priority.png";

import AdmissionEnquiry from "./AdmissionEnquiry";
import AdmissionHeader from "./AdmissionHeader";
import {
  academicPoints,
  admissionSteps,
  boardingGallery,
  carePoints,
  dailyRhythm,
  faqs,
  growthPillars,
  trustMarkers,
  whyBoarding,
} from "./admissionData";
import "./Admission2026.css";
import "./Admission2026.reference.css";

const iconSheets = {
  trust: trustIconSheet,
  why: whyIconSheet,
  growth: growthIconSheet,
  careAcademic: careAcademicIconSheet,
};

const iconSheetSizes = {
  trust: [1920, 640],
  why: [1802, 873],
  growth: [1920, 640],
  careAcademic: [1920, 640],
};

const iconCrops = {
  trust: [
    [8, 126, 384, 384], [392, 126, 384, 384], [776, 126, 384, 384],
    [1160, 126, 384, 384], [1536, 126, 384, 384],
  ],
  why: [
    [400, 12, 420, 420], [968, 12, 420, 420],
    [400, 438, 420, 420], [968, 438, 420, 420],
  ],
  growth: [
    [42, 134, 342, 342], [410, 134, 342, 342], [784, 134, 342, 342],
    [1154, 134, 342, 342], [1536, 134, 342, 342],
  ],
  careAcademic: [
    [310, 42, 270, 270], [656, 42, 270, 270], [1003, 42, 270, 270],
    [1348, 42, 270, 270], [292, 326, 306, 306], [638, 326, 306, 306],
    [984, 326, 306, 306], [1330, 326, 306, 306],
  ],
};

function AdmissionIcon({ item }) {
  if (item.spriteSet) {
    const [sheetWidth, sheetHeight] = iconSheetSizes[item.spriteSet];
    const crop = iconCrops[item.spriteSet][item.spriteIndex];

    return (
      <svg
        className={`ad26-sprite ad26-sprite-${item.spriteSet}`}
        viewBox={crop.join(" ")}
        preserveAspectRatio="xMidYMid meet"
        focusable="false"
        aria-hidden="true"
      >
        <image
          href={iconSheets[item.spriteSet]}
          width={sheetWidth}
          height={sheetHeight}
          preserveAspectRatio="none"
        />
      </svg>
    );
  }

  const Icon = item.icon;
  return <Icon aria-hidden="true" />;
}

function SectionHeading({ eyebrow, title, text, align = "left" }) {
  return (
    <div className={`ad26-section-heading ad26-heading-${align}`}>
      {eyebrow && <span className="ad26-eyebrow">{eyebrow}</span>}
      <h2>{title}</h2>
      {text && <p>{text}</p>}
    </div>
  );
}

function IconList({ items, className = "" }) {
  return (
    <div className={`ad26-icon-list ${className}`}>
      {items.map((item) => {
        return (
          <div className="ad26-icon-list-item" key={item.label}>
            <span className="ad26-icon-frame"><AdmissionIcon item={item} /></span>
            <strong>{item.label}</strong>
          </div>
        );
      })}
    </div>
  );
}

function AdmissionFooter() {
  return (
    <footer className="ad26-footer">
      <div className="ad26-shell ad26-footer-main">
        <div className="ad26-footer-brand">
          <Link to="/" aria-label="HGS Bhimtal home">
            <img src={schoolLogo} alt="HGS Bhimtal crest" />
            <span>
              <strong>HGS Bhimtal</strong>              
            </span>
          </Link>
          <p>
            A day-cum-boarding school nurturing knowledge, character and
            compassion in the hills of Bhimtal.
          </p>
        </div>

        <div className="ad26-footer-links">
          <h3>Admissions</h3>
          <a href="#why-hgs">Why HGS Bhimtal?</a>
          <a href="#boarding-life">Boarding life</a>
          <a href="#admission-process">Admission process</a>
          <a href="#faqs">Frequently asked questions</a>
        </div>

        <div className="ad26-footer-contact">
          <h3>Contact the school</h3>
          <p><FiMapPin aria-hidden="true" /> HGS Bhimtal, Nainital, Uttarakhand 263136</p>
          <a href="tel:+918126482292"><FiPhone aria-hidden="true" /> +91 81264 82292</a>
          <a href="mailto:principal.bhimtal@hgedu.org">
            <FiMail aria-hidden="true" /> principal.bhimtal@hgedu.org
          </a>
        </div>
      </div>

      <div className="ad26-shell ad26-footer-bottom">
        <p>© {new Date().getFullYear()} HGS Bhimtal</p>
        <div className="ad26-socials" aria-label="Social media links">
          <a href="https://www.facebook.com/HGSBHIMTAL1984" target="_blank" rel="noreferrer" aria-label="Facebook"><FaFacebookF /></a>
          <a href="https://www.instagram.com/hermanngmeinerschoolbhimtal/" target="_blank" rel="noreferrer" aria-label="Instagram"><FaInstagram /></a>
          <a href="https://www.linkedin.com/in/hermann-gmeiner-school-bhimtal-536464337/" target="_blank" rel="noreferrer" aria-label="LinkedIn"><FaLinkedinIn /></a>
          <a href="https://www.youtube.com/results?search_query=hermann+gmeiner+school+bhimtal" target="_blank" rel="noreferrer" aria-label="YouTube"><FaYoutube /></a>
        </div>
      </div>
    </footer>
  );
}

function Admission2026() {  
  return (
    <div className="ad26-page">
      <AdmissionHeader />

      <main>
        <section className="ad26-hero" aria-labelledby="ad26-hero-title">
          <img
            className="ad26-hero-media"
            src={heroImage}
            alt="HGS students overlooking Bhimtal Lake and the surrounding hills"
            fetchPriority="high"
          />
          <div className="ad26-hero-shade" aria-hidden="true" />
          <div className="ad26-shell ad26-hero-content">
            <span className="ad26-hero-kicker">Admissions open for 2026–27</span>
            <h1 id="ad26-hero-title">More Than a School.<br />A Second Home.</h1>
            <p>
              A safe, peaceful and inspiring environment in the hills of
              Bhimtal, where children learn, live and grow with confidence.
            </p>

            <div className="ad26-hero-facts" aria-label="School highlights">
              <span><FiBookOpen aria-hidden="true" /> CBSE curriculum</span>
              <span><FiCheck aria-hidden="true" /> Residential boarding school</span>
              <span><FiBookOpen aria-hidden="true" /> Classes Pre-Nursery–XII</span>
              <span><FiMapPin aria-hidden="true" /> Bhimtal, Uttarakhand</span>
            </div>

            <div className="ad26-hero-actions">
              <a className="ad26-button ad26-button-primary" href="#enquire">
                Download boarding prospectus <FiArrowRight aria-hidden="true" />
              </a>
              <Link className="ad26-button ad26-button-light" to="/book-tour">
                Talk to an admissions counsellor <FiArrowRight aria-hidden="true" />
              </Link>
            </div>
          </div>
        </section>

        <section className="ad26-trust-section" aria-label="HGS Bhimtal at a glance">
          <div className="ad26-shell ad26-trust-grid">
            {trustMarkers.map((marker) => {
              return (
                <article key={marker.value}>
                  <span className="ad26-icon-frame"><AdmissionIcon item={marker} /></span>
                  <div>
                    <strong>{marker.value}</strong>
                    <small>{marker.label}</small>
                  </div>
                </article>
              );
            })}
          </div>
        </section>

        <section className="ad26-overview" id="why-hgs">
          <div className="ad26-shell ad26-overview-layout">
            <div className="ad26-overview-content">
              <div className="ad26-why-panel">
              <SectionHeading
                eyebrow="Why HGS Bhimtal?"
                title="Why HGS Bhimtal?"
                text="A peaceful, pollution-free environment where children can focus, grow and discover their potential."
              />

              <div className="ad26-benefit-grid">
                {whyBoarding.map((benefit) => {
                  return (
                    <article key={benefit.title}>
                      <span className="ad26-icon-frame"><AdmissionIcon item={benefit} /></span>
                      <div>
                        <h3>{benefit.title}</h3>
                        <p>{benefit.text}</p>
                      </div>
                    </article>
                  );
                })}
              </div>

              </div>
              <div className="ad26-boarding" id="boarding-life">
                <SectionHeading
                  eyebrow="Boarding life"
                  title="A Glimpse of Boarding Life"
                  text="Familiar routines, shared experiences and attentive guidance help students feel at home."
                />
                <div className="ad26-gallery">
                  {boardingGallery.map((item) => (
                    <figure key={item.title}>
                      <img src={item.image} alt={item.alt} loading="lazy" />
                      <figcaption>{item.title}</figcaption>
                    </figure>
                  ))}
                </div>

              </div>
            </div>

            <AdmissionEnquiry />

                <div className="ad26-rhythm">
                  <div className="ad26-rhythm-copy">
                    <span className="ad26-eyebrow">A day in boarding</span>
                    <h2>A Day in the Life of a Bhimtal Boarder</h2>
                    <p>From classrooms to mountains, friendships to independence &mdash; experience what makes boarding life at HGS Bhimtal so special.</p>
                    <a href={campusVideo} target="_blank" rel="noreferrer">
                      <FiPlay aria-hidden="true" /> Watch the video
                    </a>
                  </div>
                  <div className="ad26-rhythm-grid">
                    {dailyRhythm.map((item) => {
                      const Icon = item.icon;
                      return (
                        <article key={item.time}>
                          <span><Icon aria-hidden="true" /></span>
                          <strong>{item.time}</strong>
                          <small>{item.label}</small>
                        </article>
                      );
                    })}
                  </div>
                </div>
          </div>
        </section>

        <section className="ad26-growth">
          <div className="ad26-growth-image">
            <img src={growthImage} alt="HGS Bhimtal student on the school campus" />
            <blockquote>Curious minds.<br />Compassionate hearts.<br />Confident futures.</blockquote>
          </div>
          <div className="ad26-growth-content">
            <SectionHeading
              eyebrow="Learn • live • explore • grow"
              title="Holistic Growth Beyond Books"
              text="We focus on the all-round development of every child."
            />
            <div className="ad26-pillar-grid">
              {growthPillars.map((pillar) => {
                return (
                  <article key={pillar.title}>
                    <span className="ad26-icon-frame"><AdmissionIcon item={pillar} /></span>
                    <h3>{pillar.title}</h3>
                    <p>{pillar.text}</p>
                  </article>
                );
              })}
            </div>
          </div>
        </section>

        <section className="ad26-care-academics">
          <div className="ad26-shell">
            <div className="ad26-care-band">
              <div className="ad26-feature-copy">
                <SectionHeading
                  eyebrow="Safety & care"
                  title={<>Our Highest<br />Priority</>}
                  text="When your child is away from home, care matters most."
                />
                <IconList items={carePoints} />
              </div>
              <div className="ad26-feature-image">
                <img src={careImage} alt="Boarding students studying together at HGS Bhimtal" />
                <div className="ad26-image-note">
                  <strong>“They don’t just look after our children, they help them grow.”</strong>
                  <span>— HGS parent</span>
                </div>
              </div>
            </div>

            <div className="ad26-stories-academics">
              <article className="ad26-stories">
                <div className="ad26-mini-heading">
                  <h2>Parent &amp; Student Stories</h2>
                  <p>Real experiences. Real stories. Real impact.</p>
                </div>
                <div className="ad26-story-row">
                  <div className="ad26-parent-quote">
                    <img src={parentImage} alt="HGS parent" />
                    <p>“HGS Bhimtal has given our child confidence, discipline and the happiness we always hoped for.”</p>
                  </div>
                  <a className="ad26-story-video" href={campusVideo} target="_blank" rel="noreferrer">
                    <img src={studentStoryImage} alt="HGS students on campus" />
                    <span><FiPlay aria-hidden="true" /></span>
                    <strong>Hear from our students</strong>
                  </a>
                </div>
              </article>

              <article className="ad26-academics-card">
                <div className="ad26-mini-heading">
                  <h2>Academic Excellence</h2>
                  <p>CBSE curriculum, experienced faculty and a wide range of co-curricular activities.</p>
                </div>
                <img src={academicsImage} alt="Students learning together at HGS Bhimtal" />
                <IconList items={academicPoints} className="ad26-icon-list-compact" />
              </article>
            </div>
          </div>
        </section>

        <section className="ad26-process" id="admission-process">
          <div className="ad26-shell ad26-decision-grid">
            <article className="ad26-decision-card">
              <FiFileText aria-hidden="true" />
              <h2>Understand the Investment</h2>
              <p>Get clear information about fees, the admission process and important dates.</p>
              <Link to="/admissions">View admission details <FiArrowRight aria-hidden="true" /></Link>
            </article>

            <article className="ad26-process-card">
              <h2>Admissions Process</h2>
              <div className="ad26-steps">
                {admissionSteps.map((step, index) => (
                  <div key={step.number}>
                    <span>{index + 1}</span>
                    <strong>{step.title}</strong>
                    {index < admissionSteps.length - 1 && <FiChevronRight aria-hidden="true" />}
                  </div>
                ))}
              </div>
            </article>

            <article className="ad26-decision-card ad26-assessment-card">
              <FiCheck aria-hidden="true" />
              <h2>Is Boarding Right for My Child?</h2>
              <p>Speak with our admissions team for personal guidance.</p>
              <a href="#enquire">Start a conversation <FiArrowRight aria-hidden="true" /></a>
            </article>
          </div>
        </section>

        <section className="ad26-faq" id="faqs">
          <div className="ad26-shell ad26-faq-layout">
            <SectionHeading
              eyebrow="Good to know"
              title="Frequently asked questions"
              text="Clear answers for families considering HGS Bhimtal."
            />
            <div className="ad26-faq-list">
              {faqs.map((faq) => (
                <details key={faq.question} name="ad26-faq">
                  <summary>
                    {faq.question}
                    <span aria-hidden="true">+</span>
                  </summary>
                  <p>{faq.answer}</p>
                </details>
              ))}
            </div>
          </div>
        </section>

        <section className="ad26-visit">
          <img src={heroImage} alt="Bhimtal Lake and the surrounding hills" />
          <div className="ad26-visit-overlay" aria-hidden="true" />
          <div className="ad26-shell ad26-visit-content">
            <span className="ad26-eyebrow">Come see Bhimtal</span>
            <h2>Meet us. Walk the campus. Picture your child here.</h2>
            <p>A visit lets you experience the people, spaces and routines that photographs can only begin to show.</p>
            <div>
              <Link className="ad26-button ad26-button-light" to="/book-tour">
                Book a campus visit <FiArrowRight aria-hidden="true" />
              </Link>
              <a className="ad26-visit-mail" href="mailto:principal.bhimtal@hgedu.org">
                Email admissions <FiExternalLink aria-hidden="true" />
              </a>
            </div>
          </div>
        </section>
      </main>

      <AdmissionFooter />
    </div>
  );
}

export default Admission2026;
